import { Roles } from '../pages/auth/constants/AuthConstants';

export const fullMonthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];

export enum HEARTBEAT_TYPE {
  AGENT_AMEYO_STATUS = 'AGENT_AMEYO_STATUS'
}

export const AMEYO_AVAILABILITY_KEY = 'isAmeyoAvailable';

export const REDIRECT_TIMESTAMP_RECORD = 'redirectRecordTimestamp';

export enum HRC_CALL_DISCONNECT_SOURCE_TYPE {
  USER = 'USER',
  AGENT = 'AGENT'
}

export enum KEYBOARD_KEYS {
  ENTER = 'Enter',
  ESCAPE = 'Escape',
  ARROW_DOWN = 'ArrowDown',
  ARROW_UP = 'ArrowUp'
}

export const LINE_BREAK = '\n';
export const TIME_24_HOURS = 24 * 60 * 60 * 1000;
export const WAIT_INTERVAL_BEFORE_COUNTDOWN = 60 * 1000; // 1 minute
export const COUNTDOWN_INTERVAL_BEFORE_BLOCKING = 5 * 60; // in seconds, this is 5 minutes
export const COUNTDOWN_INTERVAL_AFTER_SLASH_CALL_ENDED_BEFORE_BLOCKING = 10; // in seconds, this is 10 seconds
export const WAIT_BEFORE_LONGHORN_PERMANENT_BLOCK =
  WAIT_INTERVAL_BEFORE_COUNTDOWN + COUNTDOWN_INTERVAL_BEFORE_BLOCKING * 1000; //6 minutes;

export const COSMOS_SYNC_WAITING_FOR_CALL_BEFORE_BLOCKING = 10 * 1000; // 10 seconds time if the person is on call

export enum DEEPLINK_TYPE {
  MANDATE_SETUP = 'MANDATE_SETUP',
  EMI_DATE_CHANGE = 'EMI_DATE_CHANGE'
}

export type DeepLinkRequest = {
  type: DEEPLINK_TYPE;
  phoneNumber: string;
  loanAccountNumber?: string;
};

export const sendDeeplinkOptions = [
  { label: 'Mandate setup', value: 'MANDATE_SETUP', amount: { amount: 'NA' } },
  { label: 'EMI Date Change', value: 'EMI_DATE_CHANGE', amount: { amount: 'NA' } }
];

export const LIMIT_CALLS = {
  TOMORROW: 'tomorrow',
  DAILY_LIMIT_REACHED: 'Daily limit reached. Next call attempt available from ',
  HOURLY_LIMIT_REACHED: 'Hourly limit reached. Next call attempt available from ',
  NEXT_CALL_ATTEMPT: 'Next call attempt available from '
};

export const ameyo_errorenous_message =
  'You are marked as offline on Ameyo. please set yourself online again';

export const errorenous_break_reason = 'erroneous.channel.system.initiated.break';

export const PAUSE_CASE_LH_VISIBILITY_ROLES = [
  Roles.ROLE_COLLECTION_EFFORTS_PAUSE_ACCESS,
  Roles.ROLE_GLOBAL_ACCESS,
  Roles.ROLE_COLLECTION_HEAD,
  Roles.ROLE_USER_MANAGEMENT_ADMIN
];
export const requiredRolesForItTeam = [Roles.ROLE_USER_MANAGEMENT_ADMIN, Roles.ROLE_TEAM_LEAD];
export const IT_TEAM_ROLES_COUNT = 2;
